import { render, staticRenderFns } from "./orgdetail.vue?vue&type=template&id=77cc59db&scoped=true"
import script from "./orgdetail.vue?vue&type=script&lang=js"
export * from "./orgdetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cc59db",
  null
  
)

export default component.exports